import {
	Image,
	Show,
	Box,
	Text,
	Flex,
	Stack,
	Accordion,
} from "@chakra-ui/react";

import { CustomAccordionItem } from "../components/customAccordionItem";

import { faqs } from "../helpers";

import boobs from "../media/boobs.jpg";
import slip from "../media/slip.jpg";

export const BookingInfo = () => {
	return (
		<Flex
			id="faqs"
			pt={{ base: "4", md: "8" }}
			gap={{ base: "2", md: "8" }}
			direction={{ base: "column", md: "row" }}
		>
			<Stack w={{ md: "80%" }} gap="4">
				<Text pb="2" px={{ base: "4", md: "0" }}>
					I’m happy to answer any questions you may have but hopefully you can
					find all the information you need right here.
				</Text>

				<Show above="md">
					<Image
						h="100%"
						maxW="100%"
						src={boobs}
						rounded="3"
						alt="experience"
						objectFit="cover"
						onContextMenu={(e) => e.preventDefault()}
					/>
				</Show>
			</Stack>

			<Stack w="100%" gap="6">
				<Show above="md">
					<Box h="100%">
						<Image
							h="inherit"
							src={slip}
							rounded="3"
							alt="experience"
							objectFit="cover"
							onContextMenu={(e) => e.preventDefault()}
						/>
					</Box>
				</Show>

				<Accordion allowToggle borderY="1px" borderColor="brand.mid">
					{faqs.map(({ label, info }) => (
						<CustomAccordionItem key={label} label={label}>
							<Stack>
								{info.map((string) => (
									<Text key={string}>{string}</Text>
								))}
							</Stack>
						</CustomAccordionItem>
					))}
				</Accordion>
			</Stack>
		</Flex>
	);
};
